/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconScooterElectric = createReactComponent("scooter-electric", "IconScooterElectric", [
  ["path", { d: "M18 17m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", key: "svg-0" }],
  ["path", { d: "M6 17m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", key: "svg-1" }],
  ["path", { d: "M8 17h5a6 6 0 0 1 5 -5v-5a2 2 0 0 0 -2 -2h-1", key: "svg-2" }],
  ["path", { d: "M10 4l-2 4h3l-2 4", key: "svg-3" }]
]);

export { IconScooterElectric as default };
//# sourceMappingURL=IconScooterElectric.js.map
